import { Stack } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ScanResult from "../ScanResult";
import Report from "../TodaysReport";
import useStyle from "./styles";
import { MyContext } from "../ContextApi";
const CurrentScanList = () => {
  const navigate = useNavigate();
  const classes = useStyle();
  const { getDecryptedSessionItem } = useContext(MyContext);

  const [scanActive, setScanActive] = useState(false);

  useEffect(() => {
    if (!getDecryptedSessionItem("request_id")) {
      navigate("/scan-qr");
    }
  }, [navigate, getDecryptedSessionItem]);
  return (
    <Stack>
      <div className="row">
        <div className="col-12">
          <ScanResult setScanActive={setScanActive} />
        </div>
      </div>

      <div className="row" style={{ marginTop: 20 }}>
        <div className="col">
          <Report scanActive={scanActive} />
        </div>
      </div>
    </Stack>
  );
};

export default CurrentScanList;